import { alpha } from '@mui/material/styles';

import type { SxProps, Theme } from '@mui/material/styles';

export const CATALOG_PRODUCT_THUMB_PX = 56;

export const catalogProductItemTitleSx: SxProps<Theme> = {
    fontSize: '1.4rem',
    fontWeight: 600,
    lineHeight: '2rem',
    color: '#000000',
};

export const catalogProductDataCellSx: SxProps<Theme> = {
    verticalAlign: 'middle',
};

export const catalogProductCellTextSx: SxProps<Theme> = (theme) => ({
    fontWeight: 400,
    fontSize: '1.4rem',
    lineHeight: 'normal',
    color: alpha(theme.palette.common.black, 0.85),
});

export const catalogProductUomCellTypographySx = catalogProductCellTextSx;

export const catalogProductPriceTypographySx: SxProps<Theme> = (theme) => ({
    fontWeight: 400,
    fontSize: '1.4rem',
    lineHeight: '2rem',
    color: alpha(theme.palette.common.black, 0.85),
});

export const catalogProductCategoryTextSx: SxProps<Theme> = {
    fontWeight: 400,
    fontSize: '1.4rem',
    lineHeight: 'normal',
    color: 'rgba(0, 0, 0, 0.85)',
};

export const catalogProductColumnWidths: Record<string, string> = {
    item: '45%',
    thumbnail: '56px',
    category: '180px',
    uom: '120px',
    minOnHand: '88px',
    buttons: '48px',
    orderAdd: '110px',
};

/** Shared Table chrome for catalog/inventory/custom-list product grids. */
export const catalogProductTableSx: SxProps<Theme> = {
    '& .MuiTableCell-root': {
        borderBottom: 'none',
    },
    borderCollapse: 'separate',
    borderSpacing: '0 8px',
};

export const catalogProductTableHeadSx: SxProps<Theme> = {
    '& th': {
        paddingTop: 0,
        paddingBottom: 0,
    },
};

export const catalogProductItemHeaderCellSx: SxProps<Theme> = {
    paddingLeft: '16px',
    paddingRight: '16px',
};

export const catalogProductRowChromeSx: SxProps<Theme> = {
    cursor: 'pointer',
    boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.10)',
    borderRadius: '4px',
    '& td': {
        overflow: 'hidden',
        bgcolor: 'background.paper',
        '&:first-of-type': {
            borderRadius: '4px 0 0 4px',
        },
        '&:last-of-type': {
            borderRadius: '0 4px 4px 0',
        },
    },
};
